import { Activite } from '@/models/Activite';
import { TypeActivite } from '@/models/TypeActivite';

export interface ActivitesState {
    activites: Activite[];
    currentActivite: Activite;
    typesActivites: TypeActivite[],
    filtredActivites: FiltredActivite[],
    currentDate : string,
    isDateDiff : boolean
}

export interface FiltredActivite {
    categorie : string;
    types : FiltredType[];
    visible : boolean;
}
export interface FiltredType {
    intitule: string;
    activites: Activite[];
    visible: boolean;
}

export enum ACTIVITES_STORE {
    /* commit */
    SET_ACTIVITES = "SET_ACTIVITES",
    SET_CURRENT_ACTIVITE = "SET_CURRENT_ACTIVITE",
    SET_TYPES_ACTIVITES = "SET_TYPES_ACTIVITES",
    SET_FILTRED_ACTIVITES = "SET_FILTRED_ACTIVITES",
    SET_CURRENT_DATE ="SET_CURRENT_DATE",
    SET_IS_DATE_DIFF="SET_IS_DATE_DIFF"
}
